export default __webpack_public_path__ + "static/media/LETO-17-POURCENT-extrait-accap.786af983.mp3";